import { render, staticRenderFns } from "./BackendCard.vue?vue&type=template&id=f25f5db8&"
import script from "./BackendCard.vue?vue&type=script&lang=js&"
export * from "./BackendCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports